import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'dt-header-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements AfterViewInit {
  qIpt: HTMLInputElement;

  focus = false;

  // è¾å¥æ¡æ°æ®
  value: string;

  searchToggleStatus = false;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.qIpt = (this.el.nativeElement as HTMLElement).querySelector('.ant-input') as HTMLInputElement;
  }

  // æ´æ¹ç¶æ
  searchToggleChange() {
    this.searchToggleStatus = !this.searchToggleStatus;
    this.focus = true;
    setTimeout(() => this.qIpt.focus(), 300);
  }

  // è¾å¥æ¡è·å¾ç¦ç¹
  qFocus() {
    this.focus = true;
  }

  // è¾å¥æ¡å¤±å»ç¦ç¹
  qBlur() {
    this.focus = false;
    this.searchToggleStatus = false;
  }
}
